import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { deleteJiraCredentialsSlice } from './delete';
import { patchJiraIntegrationSlice } from './patch';
import { postJiraCredentialsSlice } from './post';
import { putJiraCredentialsSlice } from './put';
import { jiraInitiativesReducers, jiraInitiativesWatchers } from './initiatives';
import { jiraIssuesReducers, jiraIssuesWatchers } from './issues';
import { jiraStatusesReducers, jiraStatusesWatchers } from './statuses';
import { jiraSummaryReducers, jiraSummaryWatchers } from './summary';

export const jiraReducers = combineReducers({
	delete: deleteJiraCredentialsSlice.asyncReducers,
	initiatives: jiraInitiativesReducers,
	issues: jiraIssuesReducers,
	patch: patchJiraIntegrationSlice.asyncReducers,
	post: postJiraCredentialsSlice.asyncReducers,
	put: putJiraCredentialsSlice.asyncReducers,
	statuses: jiraStatusesReducers,
	summary: jiraSummaryReducers
});

export const jiraWatchers = combineAllWatchers([
	deleteJiraCredentialsSlice.asyncWatchers,
	jiraInitiativesWatchers,
	jiraIssuesWatchers,
	patchJiraIntegrationSlice.asyncWatchers,
	postJiraCredentialsSlice.asyncWatchers,
	putJiraCredentialsSlice.asyncWatchers,
	jiraStatusesWatchers,
	jiraSummaryWatchers
]);
